<template>
  <div class="authorization-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.authorizationTitle') }}</h1>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.authorization01') }}</p>
      <p>{{ $t('common.authorization02') }}<a href="./privacy.html" target="_blank">{{ $t('common.authorization03') }}</a>{{ $t('common.authorization04') }}</p>
      <h2>iOS</h2>
      <table>
        <tr>
          <th>{{ $t('common.authorizationTable01') }}</th>
          <th>{{ $t('common.authorizationTable02') }}</th>
          <th>{{ $t('common.authorizationTable03') }}</th>
        </tr>
        <template v-for="item in iosDatas" :key="item.title">
          <tr>
            <td>{{ item.title }}</td>
            <td>{{ item.desc }}</td>
            <td>{{ item.scene }}</td>
          </tr>
        </template>
      </table>
      <h2>Android</h2>
      <table>
        <tr>
          <th>{{ $t('common.authorizationTable01') }}</th>
          <th>{{ $t('common.authorizationTable02') }}</th>
          <th>{{ $t('common.authorizationTable03') }}</th>
        </tr>
        <template v-for="item in androidDatas" :key="item.title">
          <tr>
            <td>{{ item.title }}</td>
            <td>{{ item.desc }}</td>
            <td>{{ item.scene }}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
  iosDatas: {
    type: Array,
    default: () => [],
  },
  androidDatas: {
    type: Array,
    default: () => [],
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.authorizationTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
